import { getEnumValues } from "sprint-common-web";

import { getDefaultOrderListingConfig } from "../../../orders/listing/config/OrderListingConfig";

export enum OnPremOrderColumn {
    PoNumber = 1,
    Content = 2,
    Airline = 3,
    System = 4,
    StartDate = 5,
    DueDate = 6,
    Info = 7,
    Video = 8,
    Soundtracks = 9,
    Subtitles = 10,
    Status = 11,
    CreatedDate = 12,
    Runtime = 13,
    TargetFilenames = 14,
    Progress = 15,
    Actions = 16,
    Resolution = 17,
    Source = 18
}

export interface ColumnConfig {
    order: number;
    visible: boolean;
}

export interface OnPremOrderListingConfig {
    pageSize: number;
    columns: Record<OnPremOrderColumn, ColumnConfig>;
}

type ConfiguredOnPremOrderColumns = Record<OnPremOrderColumn, ColumnConfig>;

export const defaultOnPremOrderListingConfig = (): OnPremOrderListingConfig => ({
    pageSize: 50,
    columns: {
        [OnPremOrderColumn.PoNumber]: { order: 1, visible: true },
        [OnPremOrderColumn.Content]: { order: 2, visible: true },
        [OnPremOrderColumn.Airline]: { order: 3, visible: true },
        [OnPremOrderColumn.System]: { order: 4, visible: true },
        [OnPremOrderColumn.StartDate]: { order: 5, visible: true },
        [OnPremOrderColumn.DueDate]: { order: 6, visible: true },
        [OnPremOrderColumn.Progress]: { order: 7, visible: true },
        [OnPremOrderColumn.Info]: { order: 8, visible: true },
        [OnPremOrderColumn.Source]: { order: 9, visible: true },
        [OnPremOrderColumn.TargetFilenames]: { order: 10, visible: true },
        [OnPremOrderColumn.Runtime]: { order: 11, visible: true },
        [OnPremOrderColumn.Resolution]: { order: 12, visible: true },
        [OnPremOrderColumn.Video]: { order: 13, visible: true },
        [OnPremOrderColumn.Soundtracks]: { order: 14, visible: true },
        [OnPremOrderColumn.Subtitles]: { order: 15, visible: true },
        [OnPremOrderColumn.Status]: { order: 16, visible: true },
        [OnPremOrderColumn.CreatedDate]: { order: 17, visible: true },
        [OnPremOrderColumn.Actions]: { order: 18, visible: true }
    }
});

export const getSortedOrderColumns = (columnConfig: ConfiguredOnPremOrderColumns): [string, ColumnConfig][] => {
    /* ensures that columns not present in LocalStorage config (i.e. newly added) are present in the listing config modal */
    const allColumns: ConfiguredOnPremOrderColumns = { ...getInvisibleDefaultColumns(), ...columnConfig };
    const supportedColumns = new Set(getEnumValues(OnPremOrderColumn));

    return (
        Object.entries(allColumns)
            /* ensures no unrecognized values are displayed in the config dialog */
            .filter(([columnKey]) => supportedColumns.has(Number(columnKey)))
            .sort(([, valueA], [, valueB]) => {
                const columnA = valueA.order;
                const columnB = valueB.order;
                return columnA - columnB;
            })
    );
};

const getInvisibleDefaultColumns = () => {
    const defaultColumns = getDefaultOrderListingConfig().columns;
    const entries = Object.entries(defaultColumns).map(([colName, colCfg]) => [colName, { ...colCfg, visible: false }]);

    return Object.fromEntries(entries);
};
